import {
  signal,
  OnInit,
  OnDestroy,
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NoticeBannerComponent } from '../notice-banner/notice-banner.component';
import { CommonModule } from '@angular/common';
import { Observable, Subject, takeUntil } from 'rxjs';
import { UserData } from 'app/modules/user-profile/interfaces/user-profile.interface';
import { UserProfileSelectors } from 'app/modules/user-profile/state/user-profile.selector';
import { Select } from '@ngxs/store';

@Component({
  selector: 'og-subscription-banner',
  standalone: true,
  imports: [CommonModule, NoticeBannerComponent],
  templateUrl: './subscription-banner.component.html',
  styleUrls: ['./subscription-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionBannerComponent implements OnInit, OnDestroy {
  private readonly preview = false;
  isBannerDismissed = false;
  showBanner = signal(false);
  daysLeft = 0;

  @Select(UserProfileSelectors.getUserProfileState) userData$: Observable<UserData | null>;

  private unsubscribeAll$ = new Subject<void>();

  constructor(private cdr: ChangeDetectorRef) {
    this.isBannerDismissed = this.checkIfBannerDismissed();
  }

  ngOnInit() {
    if (this.preview) {
      this.daysLeft = 7;
      this.showBanner.set(true);
      return;
    }

    this.userData$.pipe(takeUntil(this.unsubscribeAll$)).subscribe((userData) => {
      if (!userData?.coach?.subscription_info?.length || this.isBannerDismissed) return;

      const latestSub = userData.coach.subscription_info.sort(
        (a, b) => new Date(b.end_date).getTime() - new Date(a.end_date).getTime()
      )[0];

      const endDate = new Date(latestSub.end_date);
      const today = new Date();
      const diffDays = Math.floor((endDate.getTime() - today.getTime()) / (1000 * 3600 * 24));

      this.daysLeft = diffDays;

      this.showBanner.set(diffDays >= 0 && diffDays <= 30);
      this.cdr.detectChanges();
    });
  }

  closeBanner() {
    if (!this.preview) localStorage.setItem('subscriptionBannerDismissed', 'true');
    this.isBannerDismissed = true;
    this.showBanner.set(false);
  }

  private checkIfBannerDismissed(): boolean {
    return localStorage.getItem('subscriptionBannerDismissed') === 'true';
  }

  ngOnDestroy() {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
